import {Component} from '@angular/core';

@Component({
  selector: 'app-assistant-ring',
  templateUrl: './assistant-ring.component.html',
  styleUrls: ['./assistant-ring.component.scss'],
  standalone: false
})
export class AssistantRingComponent {
}
